/**
 * @see https://stackoverflow.com/a/1308446/5506547
 */
function getDecimalSeparator() {
  return 1.1.toLocaleString(document.documentElement.lang).substr(1, 1);
}
const formatNumber = function (number) {
  let fixed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return number.toFixed(fixed).replace(".", getDecimalSeparator());
};
export { getDecimalSeparator, formatNumber };